module.exports = __webpack_public_path__ + "static/img/WeChat.15c413b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WeChat.png
// module id = 00gL
// module chunks = 8